export default __webpack_public_path__ + "images/arn_e03233.svg";